import { render, staticRenderFns } from "./LearnStatusManageAccount.vue?vue&type=template&id=70b674df&scoped=true&"
import script from "./LearnStatusManageAccount.vue?vue&type=script&lang=ts&"
export * from "./LearnStatusManageAccount.vue?vue&type=script&lang=ts&"
import style0 from "./LearnStatusManageAccount.vue?vue&type=style&index=0&id=70b674df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b674df",
  null
  
)

export default component.exports